import React from 'react';
import { Grid, Box } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {
  changeAirport,
  returnHorasMinutos,
  returnOneDay,
} from '@shared/helpers/flights/acordeon';
import { findScale } from '@shared/helpers/flights/flights';

const RenderScale = ({ object_option }) => {
  return (
    <Grid container>
      {/* Descripción y cambio de aeropuerto */}
      <Grid
        item
        xs={12}
        sx={{
          mb: 0.375,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          component="span"
          sx={{
            fontWeight: 700,
            fontFamily: 'Open Sans, sans-serif',
            fontSize: { xs: '0.8rem', sm: '0.9rem' },
          }}
        >
          {findScale(object_option)}
        </Box>

        {changeAirport(object_option) && (
          <Box component="span" sx={{ ml: 0.5 }}>
            <ErrorOutlineIcon fontSize="small" sx={{ color: 'red' }} />
          </Box>
        )}
      </Grid>

      {/* Indicadores de escalas */}
      <Grid
        item
        xs={12}
        sx={{
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center',
          mb: 0.375,
        }}
      >
        <Box sx={{ width: '90%', position: 'relative' }}>
          {object_option.scales_qty >= 1 && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              {object_option.flights.map((el, i) =>
                i === 0 ? null : (
                  <Box
                    key={`scale-dot-${i}`}
                    sx={{
                      display: 'inline-block',
                      minHeight: '10px',
                      minWidth: '10px',
                      backgroundColor: el.is_stop ? '#FFFFFF' : '#000000',
                      borderRadius: '5px',
                      border: '1px solid black',
                      zIndex: 3,
                      mx: 0.625,
                      position: 'relative',
                    }}
                  />
                )
              )}
            </Box>
          )}

          {/* Línea horizontal */}
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              width: '100%',
              height: '1px',
              backgroundColor: 'black',
            }}
          />
        </Box>
      </Grid>

      {/* Tiempo total de vuelo y días */}
      <Grid
        item
        xs={12}
        sx={{ mt: 0.375, display: 'flex', justifyContent: 'center', gap: 1 }}
      >
        <Box
          component="span"
          sx={{
            fontWeight: 400,
            fontFamily: 'Open Sans, sans-serif',
            fontSize: '0.8rem',
            color: '#000000',
          }}
        >
          {returnHorasMinutos(object_option.flight_time)}
        </Box>
        <Box
          component="span"
          sx={{
            fontWeight: 400,
            fontFamily: 'Open Sans, sans-serif',
            fontSize: '0.8rem',
            color: 'red',
          }}
        >
          {returnOneDay(object_option)}
        </Box>
      </Grid>
    </Grid>
  );
};

export default RenderScale;
